import { render } from "./Newsletter.vue?vue&type=template&id=a2bd69fa"
import script from "./Newsletter.vue?vue&type=script&lang=js"
export * from "./Newsletter.vue?vue&type=script&lang=js"

import "./Newsletter.vue?vue&type=style&index=0&id=a2bd69fa&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__